import { render, staticRenderFns } from "./dialog-detail-save.vue?vue&type=template&id=3f0f324a&scoped=true"
import script from "./dialog-detail-save.vue?vue&type=script&lang=js"
export * from "./dialog-detail-save.vue?vue&type=script&lang=js"
import style1 from "./dialog-detail-save.vue?vue&type=style&index=1&id=3f0f324a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f324a",
  null
  
)

export default component.exports